<template>
  <div>
    <BaseHeader
        title="ポイント基本設定"
        icon="point"
        class="point-basic-setting-header" />
    <el-row>
      <el-col :span="8">
        <div class="search-dropdown">
          <label>顧客グループ</label>
          <BaseValidSelect :value="selectedGroup"
              :options="customerGroups"
              :disabled="disabledCustomerGroups"
              name="group"
              @input="onGroupChanged" />
        </div>
        <div class="edit-table-list">
          <div class="table-vertical">
            <div class="edit-button-wrap">
              <BaseButton v-show="showEditButton"
                  :disabled="disabledEditButton"
                  @click="edit()">
                編集
              </BaseButton>
              <BaseButton v-show="showCancelButton"
                  @click="cancel()">
                キャンセル
              </BaseButton>
              <BaseButton v-show="showSaveButton"
                  @click="save()">
                保存
              </BaseButton>
            </div>
            <BaseTableDetail
                :border="true"
                :table-set-list="tableSetList"
                :display-item="settingData"
                :editable="editable" />
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import * as define from '@/define'
import { ELEMENT_TYPE } from '@/components/molecules/BaseCell'

const EDITABLE = Object.freeze({
  [define.MODE.NORMAL]: Object.freeze({}),
  [define.MODE.EDIT]: Object.freeze({ point: true, pointRate: true, roundType: true, pointUnit: true, exp: true, expUnit: true, expRule: true })
})

export default {
  name: 'PointBasicSetting',
  provide () {
    return {
      parentValidator: this.$validator
    }
  },
  data () {
    return {
      mode: define.MODE.NORMAL,
      customerGroups: [],
      selectedGroup: null,
      tableSetList: [
        {
          label: 'ポイント付与レート',
          properties: [
            { path: 'pointRate', type: 'Number', editableId: 'pointRate', elementType: ELEMENT_TYPE.INPUT_NUMBER, fractionDigits: 2 },
            { path: '%', type: 'String', elementType: ELEMENT_TYPE.FIXED_TEXT }
          ],
          horizontal: true
        }, {
          label: '丸め方法',
          properties: [
            { path: 'roundType', type: 'String', editableId: 'roundType',
              codeName: 'm_point_base_config.round_type', selectCode: 'm_point_base_config.round_type',
              elementType: ELEMENT_TYPE.SELECT_BOX }
          ]
        }, {
          label: '最小単位',
          properties: [
            { path: 'pointUnit', type: 'Number', editableId: 'pointUnit', elementType: ELEMENT_TYPE.INPUT_NUMBER },
            { path: 'ポイント', type: 'String', elementType: ELEMENT_TYPE.FIXED_TEXT }
          ],
          horizontal: true
        }, {
          label: '有効期限',
          properties: [
            { path: 'exp', type: 'Number', editableId: 'exp', elementType: ELEMENT_TYPE.INPUT_NUMBER },
            { path: 'expUnit', type: 'String', editableId: 'expUnit',
              codeName: 'm_point_base_config.expires_unit', selectCode: 'm_point_base_config.expires_unit',
              elementType: ELEMENT_TYPE.SELECT_BOX }
          ],
          horizontal: true
        }, {
          label: '失効ルール',
          properties: [
            { path: 'expRule', type: 'String', editableId: 'expRule',
              codeName: 'm_point_base_config.expire_rule', selectCode: 'm_point_base_config.expire_rule',
              elementType: ELEMENT_TYPE.SELECT_BOX }
          ]
        }
      ],
      settingData: {
        /* ポイント付与レート */
        pointRate: null,
        /* 丸め方法 */
        roundType: null,
        /* 最小単位 */
        pointUnit: null,
        /* 有効期限 */
        exp: null,
        /* 有効期限単位 */
        expUnit: null,
        /* 失効ルール */
        expRule: null
      }
    }
  },
  computed: {
    disabledCustomerGroups () {
      return this.mode === define.MODE.EDIT
    },
    disabledEditButton () {
      return !this.selectedGroup
    },
    showEditButton () {
      return this.mode === define.MODE.NORMAL
    },
    showSaveButton () {
      return this.mode !== define.MODE.NORMAL
    },
    showCancelButton () {
      return this.mode !== define.MODE.NORMAL
    },
    editable () {
      return EDITABLE[this.mode]
    }
  },
  created () {
    this.customerGroups = this.getCustomerGroups()
  },
  methods: {
    /**
     * 顧客グループを返却する.
     */
    getCustomerGroups () {
      return [
        { code: 1, name: '顧客グループ１' },
        { code: 2, name: '顧客グループ２' },
        { code: 3, name: '顧客グループ３' }
      ]
    },
    onGroupChanged (event) {
      this.selectedGroup = event
      switch (event) {
        case 1:
          this.settingData.pointRate = 1.1
          this.settingData.roundType = 1
          this.settingData.pointUnit = 13
          this.settingData.exp = 14
          this.settingData.expUnit = 10
          this.settingData.expRule = 1
          break
        case 2:
          this.settingData.pointRate = 2.1
          this.settingData.roundType = 2
          this.settingData.pointUnit = 23
          this.settingData.exp = 24
          this.settingData.expUnit = 20
          this.settingData.expRule = 2
          break
        case 3:
          this.settingData.pointRate = 3.1
          this.settingData.roundType = 3
          this.settingData.pointUnit = 33
          this.settingData.exp = 34
          this.settingData.expUnit = 30
          this.settingData.expRule = 3
          break
        default:
          this.settingData.pointRate = null
          this.settingData.roundType = null
          this.settingData.pointUnit = null
          this.settingData.exp = null
          this.settingData.expUnit = null
          this.settingData.expRule = null
          break
      }
    },
    getSelectItemName (code, selectItems) {
      let item = selectItems.filter(function (item, index) {
        if (item.code === code) {
          return true
        }
      }, this)

      return item[0] ? item[0].name : ''
    },
    edit () {
      this.mode = define.MODE.EDIT
    },
    save () {
      this.mode = define.MODE.NORMAL
    },
    cancel () {
      this.mode = define.MODE.NORMAL
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/point/PointBasicSettingTop.vue